import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export const PLAN_LIMITS = {
    starter: {
        maxItems: 50,
        maxQRs: 10,
        hasAnalytics: false,
        maxOffers: 0,
        hasChefsPicks: false,
        hasCustomLogo: true,
        hasWhatsAppReceipt: false
    },
    growth: {
        maxItems: 150,
        maxQRs: 25,
        hasAnalytics: true,
        maxOffers: 3,
        hasChefsPicks: true,
        hasCustomLogo: true,
        hasWhatsAppReceipt: false
    },
    pro: {
        maxItems: 300,
        maxQRs: 60,
        hasAnalytics: true,
        maxOffers: Infinity,
        hasChefsPicks: true,
        hasCustomLogo: true,
        hasWhatsAppReceipt: true
    },
    enterprise: {
        maxItems: 1000,
        maxQRs: Infinity,
        hasAnalytics: true,
        maxOffers: Infinity,
        hasChefsPicks: true,
        hasCustomLogo: true,
        hasWhatsAppReceipt: true
    }
};

export function useSubscription(restaurantId) {
    const [plan, setPlan] = useState(null); // null = no plan selected yet
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!restaurantId) {
            setLoading(false);
            return;
        }

        async function loadPlan() {
            try {
                const { data } = await supabase
                    .from('restaurants')
                    .select('plan')
                    .eq('id', restaurantId)
                    .single();
                
                if (data && data.plan) {
                    setPlan(data.plan);
                }
            } catch (err) {
                console.error('Error fetching subscription plan:', err);
            } finally {
                setLoading(false);
            }
        }

        loadPlan();
    }, [restaurantId]);

    // Only give limits if they actually have a paid plan. null = unpaid.
    const limits = plan ? (PLAN_LIMITS[plan] || PLAN_LIMITS.starter) : null;

    const canAddItem = (currentCount) => limits ? currentCount < limits.maxItems : false;
    const canAddQR = (currentCount) => limits ? currentCount < limits.maxQRs : false;
    const canAddOffer = (currentCount) => limits ? currentCount < limits.maxOffers : false;

    return {
        plan,
        hasActivePlan: !!plan,  // TRUE only after a real payment
        limits: limits || PLAN_LIMITS.starter,
        loading,
        canAddItem,
        canAddQR,
        canAddOffer
    };
}
